import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { SUPPORTED_LANGUAGES } from '../i18n';

export default function SidebarLanguageSelector() {
  const { t } = useTranslation('common');
  const { preferredLanguage, setPreferredLanguage } = useAuth();

  return (
    <div className="flex items-center justify-between mb-3">
      <span className="text-sm text-gray-600 dark:text-gray-400">
        {t('language')}
      </span>
      <div className="flex items-center space-x-1 bg-gray-100 dark:bg-gray-700 rounded-lg p-1">
        {SUPPORTED_LANGUAGES.map((lang) => (
          <button
            key={lang.code}
            onClick={() => setPreferredLanguage(lang.code)}
            className={`px-2.5 py-1.5 rounded text-sm font-medium transition-colors ${
              preferredLanguage === lang.code
                ? 'bg-white dark:bg-gray-600 shadow text-gray-900 dark:text-white'
                : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
            }`}
            aria-label={lang.name}
            aria-pressed={preferredLanguage === lang.code}
          >
            {lang.nativeName}
          </button>
        ))}
      </div>
    </div>
  );
}
